var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "reviews-details" } },
    _vm._l(_vm.deviceReviews, function (deviceReview, index) {
      return _c("div", { key: "review-" + index }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-4 col-md-3 col-lg-2 small fw-bold ellipsis" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(deviceReview.name) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-5 small" },
            [
              deviceReview.verified
                ? [
                    _c("span", [_vm._v(_vm._s(_vm.verified))]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "icon icon-Orange-Trust-Badge text-primary trust-badge",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 py-1" },
            [
              deviceReview.rating
                ? _c("Rating", {
                    attrs: {
                      average: deviceReview.rating,
                      "rating-results-height": 1.25,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("p", {
                directives: [
                  {
                    name: "msh-html",
                    rawName: "v-msh-html",
                    value: deviceReview.description,
                    expression: "deviceReview.description",
                  },
                ],
                staticClass: "text-mw mb-0",
              }),
              _vm._v(" "),
              deviceReview.originallyPublished
                ? _c("p", {
                    directives: [
                      {
                        name: "msh-html",
                        rawName: "v-msh-html",
                        value: deviceReview.originallyPublished,
                        expression: "deviceReview.originallyPublished",
                      },
                    ],
                    staticClass: "mb-0 small",
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        index !== _vm.deviceReviews.length - 1
          ? _c(
              "div",
              { staticClass: "col-12 px-0" },
              [_c("ob1-separateur", { staticClass: "mb-1" })],
              1
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }